module.exports = __webpack_public_path__ + "media/images/pack-02-84b729206bbcc6dfcfbacdd4d3fd5fdd.webp";